import { Button } from "react-aria-components";
import styled from "@emotion/styled";

export const SimpleButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
`;
